
export const ProductTabList = [
	{
		id: "productList",
		title: "Product list",
	},

	{
		id: "orderHistory",
		title: "Order history",
	},

	{
		id: "customers",
		title: "Customers",
	},

	{
		id: "categories",
		title: "Categories",
	},

	{
		id: "cart",
		title: "Cart",
	},
];




export const ProductHeadCells = [
	{ field: "image", title: "PRODUCT IMAGE", sortable: false,  width: 150 },
	{ field: "createdAt", title: "DATE/TIME",  width: 100 },
	{ field: "productName", title: "PRODUCT NAME", width: 150 },
	{ field: "shelfLife", title: "SHELF LIFE", width: 100 },
	{ field: "admin", title: "ADMIN", width: 120 },
	{ field: "category", title: "CATEGORY", width: 70 },
	{ field: "amount", title: "AMOUNT", sortable: false, width: 70 },
	{ field: "totalUnits", title: "TOTAL UNITS", sortable: false, width: 30 },
	{ field: "approve", title: "APPROVAL", width: 70 },
	{
		field: "availableUnits",
		title: "AVAILABLE UNITS",
		sortable: false,
		width: 50,
	},
	{ field: "typeProduct", title: "ACTION", sortable: false, width: 50 },
];

export const OrderHistoryCells = [
	{ field: "createdAt", title: "DATE/TIME", width: 100 },
	{ field: "transactionId", title: "TRANSACTION ID", width: 70 },
	{ field: "asset", title: "ASSET", width: 70 },
	{ field: "value", title: "VALUE", width: 70 },
	{ field: "amount", title: "AMOUNT", width: 70 },
	{ field: "paymentType", title: "PAYMENT TYPE", width: 70 },
	{ field: "paymentMethod", title: "PAYMENT METHOD", sortable: false, width: 70 },
	{ field: "saleStatus", title: "SALE STATUS", sortable: false, width: 100 },
	{ field: "typeOrder", title: "ACTION", sortable: false, width: 70 },
];


export const CustomerCells = [
	{ field: "createdAt", title: "DATE/TIME", width: 100 },
	{ field: "email", title: "EMAIL", width: 100 },
	{ field: "phone", title: "PHONE NUMBER", width: 100 },
	{ field: "firstName", title: "NAME", width: 100 },
	{ field: "lastPurchase", title: "LAST PURCHASE", width: 70 },
	{ field: "typeCustomer", title: "Action", sortable: false, width: 70 },
];


export const CartCells = [
	{ field: "productImage", title: "PRODUCT IMAGE", width: 150 },
	{ field: "createdAt", title: "DATE/TIME", width: 100 },
	{ field: "productName", title: "PRODUCT NAME", width: 70 },
	{ field: "name", title: "CUSTOMER", width: 70 },
	{ field: "amount", title: "AMOUNT", width: 70 },
	{ field: "quantity", title: "QUANTITY", sortable: false, width: 70 },
	{ field: "total", title: "TOTAL", sortable: false, width: 70 },
	// { field: "type", title: "Action", sortable: false, width: 70 },
];